module.exports = __webpack_public_path__ + "static/media/intro.9b9fac89.mp3";